import { WidgetAutocheck } from "@redotech/redo-model/widget";
import { sortBy } from "lodash";
import { RedoCheckboxElement } from "./checkbox-app";
import "./styles.css";
import "./styles.global.css";

const CONTAINER_ID = "redo-checkbox";

const FORM_SELECTOR =
  '[action="/cart/add"]:not(#product-form-installment):not(.installment)';

export const TAPCART_SELECTOR = "#redo_tapcart_container";

function addContainer(
  widgetId: string,
  autocheck: WidgetAutocheck,
  onTapcart: boolean,
) {
  if (!autocheck.enabled) {
    return;
  }
  const selector = onTapcart
    ? TAPCART_SELECTOR
    : autocheck.selector || FORM_SELECTOR;
  const forms = document.querySelectorAll(selector);
  const sortedForms = sortBy(
    forms,
    (form) =>
      !form.querySelector('button[type="submit"], input:not([type="hidden"])'),
  );
  // They have an identical form that is invisible, so we need to select 2nd form
  const form = onTapcart
    ? sortedForms[0]
    : sortedForms[Shopify.shop === "palmdancewear.myshopify.com" ? 1 : 0];
  if (!form) {
    return;
  }
  const container = document.createElement("div");
  container.id = CONTAINER_ID;
  form.appendChild(container);
  return container;
}

export function addCheckbox(
  autocheck: WidgetAutocheck,
  onTapcart: boolean,
): RedoCheckboxElement | null {
  const container =
    document.getElementById(CONTAINER_ID) ||
    addContainer(window.redoWidgetId, autocheck, onTapcart);
  if (!container) {
    return null;
  }

  RedoCheckboxElement.register();

  const checkbox = document.createElement(
    RedoCheckboxElement.TAG,
  ) as RedoCheckboxElement;

  container.append(checkbox);

  return checkbox;
}
